import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { RecordingManagementService } from "@onsip/common/services/api/resources/recordingManager/recording-manager.service";
import { AddressSummaryService } from "@onsip/common/services/api/resources/addressSummary/address-summary.service";
import { map, startWith } from "rxjs/operators";
import { views } from "@onsip/web/app/phone/views";
import { UserAliasService } from "@onsip/common/services/api/resources/userAlias/user-alias.service";

@Component({
  selector: "onsip-recording-manager",
  templateUrl: "./recording-manager.component.html",
  styleUrls: ["./recording-manager.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class RecordingManagerComponent implements OnInit {
  voicePanel$ = new BehaviorSubject<"view" | "edit">("view");
  recManagement$ = this.recManagementService.orgState.pipe(map(recManager => recManager[0]));
  isLoaded$ = this.recManagement$.pipe(
    map(() => true),
    startWith(false)
  );
  views = views;

  togglePanel(panel: "view" | "edit"): void {
    this.voicePanel$.next(panel);
  }

  constructor(
    private recManagementService: RecordingManagementService,
    private addressSummaryService: AddressSummaryService,
    private userAliasService: UserAliasService
  ) {}

  ngOnInit(): void {
    this.recManagementService.recordingManagementBrowse();
    this.addressSummaryService.addressSummaryBrowse();
    this.userAliasService.userAliasBrowse();
  }
}
